import { ClientConstants as Constants } from '../types'

const initialState = {
    clients: [],
    client: null  
};

export function clientReducer(state = initialState, action) {
    switch (action.type) {  
        
        case Constants.GET:            
            return {
                ...state,
                clients: action?.payload?.clients,
            };

        case Constants.DETAILS:            
            return {
                ...state,
                client: action?.payload?.client,
            };

   
            
        case Constants.ADD:
            return {
                ...state,
                clients: [...state?.clients, action?.payload?.client]                
            }

        case Constants.UPDATE:            
            const index = state.clients.findIndex(x => x.id ===  action?.payload?.client?.id)
            const newArray = [...state.clients];
            if(index > -1)
                newArray[index] = action?.payload?.client
            return {
                ...state,
                clients: newArray                
            }   

        case Constants.DELETE:
            return{
                ...state,
                clients: state?.clients?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id))                
            };
       
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null
            }

        case Constants.CLEAR_DETAILS:
            return{
                ...state,
                client: null
            }
            
        case Constants.CLEAR:
        default:
            return state
    }
}